export default __webpack_public_path__ + "static/media/matic_cryptocurrency_logo_icon_131424.004b10a8.svg";